"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _zenscroll = _interopRequireDefault(require("zenscroll"));

var _loader = _interopRequireDefault(require("../loader"));

var _horizontalScroll = _interopRequireDefault(require("./horizontal-scroll"));

var _rows = _interopRequireDefault(require("./rows"));

var _headCell = _interopRequireDefault(require("./head-cell"));

var _message = _interopRequireDefault(require("./message"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var _ref = /*#__PURE__*/_jsx(_loader["default"], {
  size: "xlg",
  centered: true
});

var Table = /*#__PURE__*/function (_Component) {
  _inherits(Table, _Component);

  var _super = _createSuper(Table);

  function Table() {
    var _this;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      headHeight: 0,
      wrapperWidth: 0
    });

    _defineProperty(_assertThisInitialized(_this), "wrapperRef", /*#__PURE__*/(0, _react.createRef)());

    _defineProperty(_assertThisInitialized(_this), "scrollWrapperRef", /*#__PURE__*/(0, _react.createRef)());

    _defineProperty(_assertThisInitialized(_this), "headRef", /*#__PURE__*/(0, _react.createRef)());

    _defineProperty(_assertThisInitialized(_this), "lastScrollX", 0);

    _defineProperty(_assertThisInitialized(_this), "lastScrollY", 0);

    _defineProperty(_assertThisInitialized(_this), "scrolling", false);

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function () {
      var scrollWrapper = _this.scrollWrapperRef.current;

      if (!scrollWrapper) {
        return;
      }

      if (scrollWrapper.scrollTop !== _this.lastScrollY) {
        _this.onVerticalScroll();
      }

      _this.lastScrollX = scrollWrapper.scrollLeft;
      _this.lastScrollY = scrollWrapper.scrollTop;
    });

    _defineProperty(_assertThisInitialized(_this), "onVerticalScroll", function () {
      var wrapperEl = _this.wrapperRef.current;

      if (!wrapperEl) {
        return;
      } // only one scrolling animation


      if (!_this.scrolling) {
        _this.scrolling = true;
        var animationSpeed = 300;

        _zenscroll["default"].to(wrapperEl, animationSpeed);

        setTimeout(function () {
          return _this.scrolling = false;
        }, animationSpeed);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderFetching", function () {
      return /*#__PURE__*/_jsx(_message["default"], {
        colSpan: _this.props.columns.length,
        scrollWrapperRef: _this.scrollWrapperRef
      }, void 0, _this.props.renderFetchingMessage ? // $FlowFixMe - this.props.renderFetchingMessage is undefined
      _this.props.renderFetchingMessage({
        columns: _this.props.columns,
        className: cx('xsui-table-message')
      }) : _ref);
    });

    _defineProperty(_assertThisInitialized(_this), "renderEmptyMessage", function () {
      return /*#__PURE__*/_jsx(_message["default"], {
        colSpan: _this.props.columns.length,
        scrollWrapperRef: _this.scrollWrapperRef
      }, void 0, _this.props.renderEmptyMessage && // $FlowFixMe - this.props.renderEmptyMessage is undefined
      _this.props.renderEmptyMessage({
        columns: _this.props.columns,
        className: cx('xsui-table-message')
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderRows", function () {
      if (_this.props.fetching) {
        return _this.renderFetching();
      }

      if (!_this.props.rows.length) {
        return _this.renderEmptyMessage();
      }

      return /*#__PURE__*/_jsx(_rows["default"], {
        rows: _this.props.rows,
        columns: _this.props.columns,
        renderRow: _this.props.renderRow,
        compact: _this.props.compact
      });
    });

    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // disable auto smooth scroll for all links
      window.noZensmooth = true;
      var headEl = this.headRef.current;
      var scrollWrapperEl = this.scrollWrapperRef.current;

      if (headEl) {
        this.setState({
          headHeight: headEl.clientHeight
        });
      }

      if (scrollWrapperEl && this.props.stickyHead) {
        this.lastScrollX = scrollWrapperEl.scrollLeft;
        this.lastScrollY = scrollWrapperEl.scrollTop;
        scrollWrapperEl.addEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var headEl = this.headRef.current;

      if (headEl && this.state.headHeight !== headEl.offsetHeight) {
        this.setState({
          headHeight: headEl.offsetHeight
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var scrollWrapperEl = this.scrollWrapperRef.current;

      if (scrollWrapperEl) {
        scrollWrapperEl.removeEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columns = _this$props.columns,
          className = _this$props.className,
          tableClassName = _this$props.tableClassName,
          scrollWrapperClassName = _this$props.scrollWrapperClassName,
          compact = _this$props.compact,
          horizontalScroll = _this$props.horizontalScroll,
          stickyHead = _this$props.stickyHead,
          tableWrapperDataId = _this$props.tableWrapperDataId;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.wrapperRef,
        className: cx('xsui-table__wrapper', className),
        "data-id": tableWrapperDataId
      }, horizontalScroll && /*#__PURE__*/_jsx(_horizontalScroll["default"], {
        headHeight: this.state.headHeight,
        headRef: this.headRef,
        scrollWrapperRef: this.scrollWrapperRef
      }), /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.scrollWrapperRef,
        className: cx('xsui-table__scroll-wrapper', scrollWrapperClassName)
      }, /*#__PURE__*/_jsx("table", {
        className: cx('xsui-table', tableClassName)
      }, void 0, /*#__PURE__*/_jsx("thead", {}, void 0, /*#__PURE__*/_react["default"].createElement("tr", {
        ref: this.headRef,
        className: cx('xsui-table__row', 'xsui-table__head-row')
      }, columns.map(function (column, idx) {
        return /*#__PURE__*/_jsx(_headCell["default"], {
          column: column,
          compact: compact,
          stickyRow: stickyHead
        }, "column-".concat(idx));
      }))), this.renderRows())));
    }
  }]);

  return Table;
}(_react.Component);

_defineProperty(Table, "defaultProps", {
  columns: [],
  rows: [],
  className: '',
  tableClassName: '',
  scrollWrapperClassName: '',
  fetching: false,
  compact: false,
  horizontalScroll: false,
  stickyHead: false
});

var _default = Table;
exports["default"] = _default;